import { Button, Modal, message } from 'antd';
import React, { Component } from 'react'
import NewVisitPeriodPlan from '../../visitPeriodPlan';
import '../../css/style.less';
import NewPlanVisitParams from '../../visitPeriodPlan/components/PlanVisitParams';

export default class SetPlanParams extends Component {
    state = {
        visible: false,
        evaluateRecordId: '',
        chooseType: 'visitPeriodPlan',
        type: '',
    }

    show = (evaluateRecordId, type) => {
        this.setState({
            visible: true,
            evaluateRecordId,
            type,
        })
    }

    hide = () => {
        const { evaluateRecordId } = this.state;
        this.setState({
            visible: false,
        }, () => {
            if (this.props.loadData && evaluateRecordId) {
                this.props.loadData(evaluateRecordId);
            }
        })
    }

    getContent = () => {
        const { evaluateRecordId, chooseType, type } = this.state;
        const { record } = this.props;
        let content = null;
        switch (chooseType) {
            case 'visitPeriodPlan':
                content = <NewVisitPeriodPlan evaluateRecordId={evaluateRecordId} type={type} record={record}/>
                break;
            case 'planVisitParams':
                content = <NewPlanVisitParams evaluateRecordId={evaluateRecordId} type={type} record={record}/>
                break;
        }
        return (
            content
        )
    }

    changeType = (chooseType) => {
        this.setState({ chooseType });
    }

    render() {
        const { visible, chooseType } = this.state;
        return (
            <Modal
                title={'计划访视参数设置'}
                visible={visible}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={1400}
                bodyStyle={{
                    minHeight: 700
                }}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >   
            <div className="full home">
                <div className='change-btn' style={{ marginBottom: 30 }}>
                    <a className={chooseType == "visitPeriodPlan" ? 'cur' : ''} onClick={() => {this.changeType('visitPeriodPlan')}}>访视周期计划</a>
                    <a className={chooseType == "planVisitParams" ? 'cur' : ''} onClick={() => {this.changeType('planVisitParams')}}>计划访视参数设置</a>
                </div>
                {this.getContent()}
            </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/SetPlanParams.js